import { Typography, Button } from '@mui/material';
import brandIcon from './assets/Data Centres Primary Horizontal Lock-up.png';
import ReplayIcon from '@mui/icons-material/Replay';

// Fallback page when forced maintenance is occuring
const MaintenancePage = (props) => {
  const { title, description } = props;
  return (
    <div
      className="col gap-lg align-center justifty-center"
      style={{ width: '512px', margin: '256px auto' }}
    >
      <img
        src={brandIcon}
        style={{ maxHeight: '80px', marginBottom: '64px', paddingRight: '16px' }}
      />
      <Typography variant="h3">{title}</Typography>
      <Typography variant="body2" style={{ textAlign: 'center' }}>
        {description}
      </Typography>
      <Button
        onClick={() => (window.location.href = '/')}
        sx={{ marginTop: 2 }}
        disableElevation
        variant="contained"
        color="primary"
        // startIcon={<ArrowBackRoundedIcon />}
        endIcon={<ReplayIcon />}
      >
        Reload App
      </Button>
    </div>
  );
};

export default MaintenancePage;
